import { Nillable } from '@web/utils';

export class DictionaryDetailsForm {
  public constructor(
    private readonly data: {
      label: string;
      position: number;
      slug?: Nillable<string>;
    },
  ) {}

  public get label(): string {
    return this.data.label;
  }

  public get position(): number {
    return this.data.position;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }
}
